<template>
  <div id="page3">
    <div class="codePlaceWrap" id="codePlaceWrap">
        <h2>涿溪防窜货适用场景</h2>
        <p>全国5000家日化企业适用场景</p>
        <div class="placeMain">
          <transition name="place">
            <div class="placeItem" v-show="blockShow">
              <div class="placeMsg">为品牌正名，提升品牌影响力</div>
              <div class="placeTit">品牌营销</div>
              <img clss="ppyx" src="../assets/images/icon_ppyx.png" />
            </div>
          </transition>
          <transition name="place">
            <div class="placeItem" v-show="blockShow">
              <div>
                <div class="placeTit">一物一码</div>
                <div class="placeMsg">基于国家标识，一物赋一码</div>
              </div>
              <img class="ywym" src="../assets/images/icon_ywym.png" />
            </div>
          </transition>
          <transition name="place">
            <div class="placeItem" v-show="blockShow">
              <img class="lbfg" src="../assets/images/icon_lbfg.png" />
              <div>
                <div class="placeTit">裂变复购</div>
                <div class="placeMsg">防伪码集成，H5链接商城复购</div>
              </div>
            </div>
          </transition>
          <transition name="place">
            <div class="placeItem" v-show="blockShow">
              <div>
                <div class="placeTit">防伪防窜</div>
                <div class="placeMsg">国家标识防伪防窜，有据可查</div>
              </div>
              <img class="fwfc" src="../assets/images/icon_lbfg.png" />
            </div>
          </transition>
          <transition name="place">
            <div class="placeItem" v-show="blockShow">
              <img class="dsj" src="../assets/images/icon_dsj.png" />
              <div>
                <div class="placeTit">大数据管理</div>
                <div class="placeMsg">BOSS端实时查看，用户扫码数据</div>
              </div>
            </div>
          </transition>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'codeplace',
  props:{
    blockShow: Boolean,
    scroll:{
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      // blockShow: false,
      wrapTop: 0, // 距离顶部距离
      offsetHeight: 0, // dom节点本身高度
    }
  },
  methods:{

  },
  mounted: function(){
    // this.blockShow = true
    // this.wrapTop = document.getElementById('codePlaceWrap').offsetTop
    // this.offsetHeight = document.getElementById('codePlaceWrap').offsetHeight
  },
  watch:{
    // scroll(val) {
    //   if(this.wrapTop === 0) {
    //     this.blockShow = true
    //   }
    //   if(!this.blockShow) {
    //     if(this.scroll >= this.wrapTop-200 && this.scroll < (this.wrapTop + this.offsetHeight)) {
    //       this.blockShow = true
    //     }
    //   }
    //   if(this.blockShow) {
    //     if((this.scroll < this.wrapTop-200) || (this.scroll > (this.wrapTop + this.offsetHeight))){
    //       this.blockShow = false
    //     }
    //   }
    // }
  }
}
</script>
<style scoped lang="scss">
/**动画**/
.place-enter-active {
  animation: place-in .5s;
  animation-delay: .3s;
}
.place-leave-active {
  animation: place-in .5s reverse;
  animation-delay: 0s;
}

@keyframes place-in {
  0% {
    transform: scale(0.1);
    opacity: 0.2;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.codePlaceWrap{
  >h2 {
    font-size: 40px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #1F2329;
    line-height: 56px;
    // margin-top: 42px;
    margin-bottom: 18px;
    text-align: center;
  }
  > p{
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #707885;
    line-height: 28px;
    text-align: center;
  }

  .placeMain{
    // width: 1098px;
    width: 85%;
    margin:  0 auto;
    height: 693px;
    background: url('../assets/images/bg_2.png') top center no-repeat;
    position: relative;
    .placeItem{
      position: absolute;
      .placeTit{
        font-size: 24px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: normal;
        color: #36444D;
        line-height: 33px;
      }
      .placeMsg{
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: normal;
        color: #707885;
        line-height: 24px;
      }
      img {
        margin: 17px;
        width: 82px;
        height: 82px;
      }
      &:nth-child(1) {
        top: 55px;
        left: 50%;
        margin-left: -100px;
        text-align: center;
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
      }
      &:nth-child(2) {
        top: 230px;
        left: 80px;
        text-align: right;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      &:nth-child(3) {
        top: 230px;
        right: 55px;
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      &:nth-child(4) {
        top: 420px;
        left: -10px;
        text-align: right;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      &:nth-child(5) {
        top: 420px;
        right: -45px;
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CodePlace.vue